import React from 'react';
import { StoreIcon, LayoutTemplateIcon, BlocksIcon, LineChartIcon } from 'lucide-react';
import { usePageSEO } from '../hooks/usePageSEO';
export function ServicesPage() {
  usePageSEO({
    title: 'Services | Design Flow Digitals',
    description: 'Explore our Shopify services: custom store development, theme design, app development, and CRO optimization. Design Flow Digitals delivers premium ecommerce solutions.'
  });
  const services = [{
    icon: <StoreIcon className="w-10 h-10 text-[#D4AF37]" data-id="element-893" />,
    title: 'Shopify Store Development',
    description: 'We design and develop premium Shopify stores tailored to your brand and audience.',
    features: ['Custom storefront design', 'Product page optimization', 'Checkout optimization', 'SEO setup', 'Performance tuning']
  }, {
    icon: <LayoutTemplateIcon className="w-10 h-10 text-[#D4AF37]" data-id="element-894" />,
    title: 'Shopify Theme Development',
    description: 'Custom Shopify themes built for speed, flexibility and scalability.',
    features: ['Modular architecture', 'Advanced customization options', 'Fast loading speeds', 'Mobile optimized design']
  }, {
    icon: <BlocksIcon className="w-10 h-10 text-[#D4AF37]" data-id="element-895" />,
    title: 'Shopify App Development',
    description: 'We develop powerful Shopify apps that add new capabilities to stores.',
    features: ['Product customization tools', 'Advanced analytics dashboards', 'Upsell and cross sell systems', 'Automation workflows']
  }, {
    icon: <LineChartIcon className="w-10 h-10 text-[#D4AF37]" data-id="element-896" />,
    title: 'Conversion Optimization',
    description: "Improve your store's performance with data-driven strategies.",
    features: ['User behavior analysis', 'Checkout optimization', 'A/B testing', 'Funnel improvements']
  }];
  return <div className="pt-32 pb-20" data-id="element-897">
      <section className="px-6 md:px-12 max-w-5xl mx-auto text-center mb-24" data-id="element-898">
        <h1 className="text-5xl md:text-7xl font-bold mb-8" data-id="element-899">Our Services</h1>
        <p className="text-xl md:text-2xl text-gray-400 leading-relaxed" data-id="element-900">
          End-to-end Shopify solutions designed for premium merchants.
        </p>
      </section>

      <section className="section-padding" data-id="element-901">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-902">
          {services.map((service, index) => <div key={index} className="glass-card p-10 flex flex-col h-full border-white/10 hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-903">
              <div className="w-20 h-20 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center mb-8" data-id="element-904">
                {service.icon}
              </div>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-905">
                {service.title}
              </h2>
              <p className="text-lg text-gray-400 mb-8 leading-relaxed" data-id="element-906">
                {service.description}
              </p>
              <div className="mt-auto" data-id="element-907">
                <h3 className="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-4" data-id="element-908">
                  Includes / Features:
                </h3>
                <ul className="space-y-3" data-id="element-909">
                  {service.features.map((feature, fIndex) => <li key={fIndex} className="flex items-center gap-3 text-gray-300" data-id="element-910">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" data-id="element-911" />
                      {feature}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </section>
    </div>;
}